/**
 * Quote Request
 * -------------------------------------------------------------
 * Lets customers send the items they're interested in to the
 * "Request a Quote" page (handle: get-a-quote), where the
 * contact form is pre-filled with those items.
 *
 * Flow:
 *  - Product page button: stores the single product/variant.
 *  - Cart (page + drawer) button: reads the live cart via /cart.js
 *    and stores every line item.
 *  - Stored under sessionStorage (robust, no URL length limits),
 *    with a ?quote=1 flag so the form knows to read it.
 *  - The quote page reads the stored payload and fills a textarea
 *    named contact[Requested Items], which the customer can edit.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'aed_quote_items';
  var QUOTE_PAGE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root + 'pages/get-a-quote'
    : '/pages/get-a-quote';

  function moneyFromCents(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2);
  }

  // Build a human-readable, editable list of items.
  function formatItems(items) {
    if (!items || !items.length) return '';
    var lines = items.map(function (it) {
      var parts = [];
      parts.push((it.quantity || 1) + ' x ' + it.title);
      if (it.variant && it.variant !== 'Default Title') {
        parts.push('(' + it.variant + ')');
      }
      if (it.sku) parts.push('SKU: ' + it.sku);
      return '- ' + parts.join(' ');
    });
    return lines.join('\n');
  }

  function storeAndGo(items) {
    var payload = {
      items: items,
      text: formatItems(items),
      ts: Date.now()
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      // sessionStorage may be unavailable; fall back to URL text (truncated-safe).
      var url = QUOTE_PAGE + '?quote=1&items=' + encodeURIComponent(payload.text);
      window.location.href = url;
      return;
    }
    window.location.href = QUOTE_PAGE + '?quote=1';
  }

  // ---- Product page: single product ----
  function handleProductButton(button) {
    var form = button.closest('form[data-type="add-to-cart-form"]')
      || (button.closest('product-form') && button.closest('product-form').querySelector('form'));
    var variantId = null;
    var variantTitle = button.getAttribute('data-variant-title') || '';
    var sku = button.getAttribute('data-sku') || '';

    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) variantId = idInput.value;
    }

    var item = {
      title: button.getAttribute('data-product-title') || document.title,
      variant: variantTitle,
      sku: sku,
      quantity: 1,
      variantId: variantId
    };

    // Respect a quantity selector if present on the page.
    var qtyInput = document.querySelector('.product input[name="quantity"], quantity-input input[name="quantity"]');
    if (qtyInput && parseInt(qtyInput.value, 10) > 0) {
      item.quantity = parseInt(qtyInput.value, 10);
    }

    storeAndGo([item]);
  }

  // ---- Cart: all line items via /cart.js ----
  function handleCartButton(button) {
    button.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (line) {
          return {
            title: line.product_title,
            variant: line.variant_title || '',
            sku: line.sku || '',
            quantity: line.quantity,
            variantId: line.variant_id
          };
        });
        button.classList.remove('is-loading');
        if (!items.length) {
          window.location.href = QUOTE_PAGE + '?quote=1';
          return;
        }
        storeAndGo(items);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        window.location.href = QUOTE_PAGE;
      });
  }

  function onClick(e) {
    var button = e.target.closest('[data-quote-request]');
    if (!button) return;
    e.preventDefault();
    var scope = button.getAttribute('data-quote-request');
    if (scope === 'cart') {
      handleCartButton(button);
    } else {
      handleProductButton(button);
    }
  }

  // ---- Quote page: prefill the form ----
  function prefillQuoteForm() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('quote') !== '1' && !params.get('items')) return;

    var field = document.querySelector('[name="contact[Requested Items]"]');
    if (!field) return;

    var text = '';
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var payload = JSON.parse(raw);
        text = payload.text || '';
      }
    } catch (e) { /* ignore */ }

    if (!text && params.get('items')) {
      text = params.get('items');
    }

    if (text) {
      field.value = text;
      // Trigger label float / change listeners.
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
      // Clear so a refresh doesn't re-fill stale data.
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
  }

  document.addEventListener('click', onClick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillQuoteForm);
  } else {
    prefillQuoteForm();
  }
})();
